import React from 'react'
import styles from './TimeStyles'

const formatTime = (seconds) => {
  const date = new Date(Date.UTC(1970, 1, 1, 0, 0, 0, 0))
  seconds = isNaN(seconds) || seconds > 86400
    ? 0
    : Math.floor(seconds)
  date.setSeconds(seconds)
  return date.toISOString().substr(11, 8).replace(
    /^0{1,2}:?0{0,1}/, ''
  )
}

export default ({ currentTime, duration, className }) => {
  return (
    <div className={styles.component}>
      <span className={styles.current}>
        { formatTime(currentTime) }
      </span>
      /
      <span className={styles.duration}>
        { formatTime(duration) }
      </span>
    </div>
  )
}



// WEBPACK FOOTER //
// ./src/Components/VideoPlayer/Time/Time.js